import clsx from 'clsx'
import React from 'react'

type InputProps = Omit<React.InputHTMLAttributes<HTMLInputElement>, 'disabled'> & {
  isDisabled?: boolean
  variant?: 'solid' | 'outline'
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ variant = 'solid', type = 'text', isDisabled, value, className, ...props }, ref) => {
    return (
      <input
        {...props}
        ref={ref}
        value={value ?? ''}
        disabled={isDisabled}
        className={clsx('form-control', className, {
          'form-control-solid': variant === 'solid',
        })}
        autoComplete="off"
      />
    )
  }
)

export type { InputProps }

export { Input }
